import { FC } from 'react';

type Props = {
	className?: string;
};

const SquareLock_02_IconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.99978 3.48834C8.5613 3.48834 7.39518 4.65446 7.39518 6.09294V7.25397C8.22696 7.22444 9.08103 7.2092 9.99978 7.2092C10.9185 7.2092 11.7726 7.22444 12.6044 7.25397V6.09294C12.6044 4.65446 11.4383 3.48834 9.99978 3.48834ZM5.90684 6.09294V7.41542C4.74022 7.77243 3.85981 8.79882 3.69257 10.0409C3.58231 10.8598 3.48828 11.7202 3.48828 12.6044C3.48828 13.4887 3.58232 14.3491 3.69257 15.168C3.89467 16.6689 5.13823 17.8549 6.66978 17.9253C7.73277 17.9742 8.81224 17.9997 9.99978 17.9997C11.1873 17.9997 12.2668 17.9742 13.3298 17.9253C14.8613 17.8549 16.1049 16.6689 16.307 15.168C16.4172 14.3491 16.5113 13.4887 16.5113 12.6044C16.5113 11.7202 16.4172 10.8598 16.307 10.0409C16.1397 8.79882 15.2594 7.77243 14.0927 7.41542V6.09294C14.0927 3.83247 12.2603 2 9.99978 2C7.73931 2 5.90684 3.83247 5.90684 6.09294ZM10.744 11.8603C10.744 11.4493 10.4108 11.1161 9.99978 11.1161C9.58878 11.1161 9.25561 11.4493 9.25561 11.8603V13.3486C9.25561 13.7596 9.58878 14.0928 9.99978 14.0928C10.4108 14.0928 10.744 13.7596 10.744 13.3486V11.8603Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default SquareLock_02_IconSolid;
